export interface ILookObject {
  category: string;

  color_a?: number;
  color_r?: number;
  color_g?: number;
  color_b?: number;

  intensity?: number;

  sparkle_a?: number;
  sparkle_r?: number;
  sparkle_g?: number;
  sparkle_b?: number;

  gamma?: number;
  glossDetail?: number;
  wetness?: number;

  // Foundation Only
  skinGlow?: number;
  skinClearing?: number;
  contrastBoost?: number;
  placement: string;
}

export enum EModifaceApiDataType {
  HAIR = 'Hair',
  MAKE_UP = 'Makeup',
}
